import "./ReportInsightContainer.css";

const ReportInsightContainer = ({
  title,
  children,
  className = "",
  insightCardClassName = "",
  ...props
}) => {
  return (
    <div className={`report-insight-container ${className}`} {...props}>
      <h3 className="insight-title">{title}</h3>
      <div className={`insight-card ${insightCardClassName}`}>{children}</div>
    </div>
  );
};

export default ReportInsightContainer;
